<template>
  <section :class="$style.loadingWrapper">
    <a-spin v-if="loading">
      <a-icon slot="indicator" :component="IconWait" spin />
    </a-spin>
    <slot v-else />
  </section>
</template>

<script>
import { Spin, Icon } from "ant-design-vue";
import IconWait from "@/assets/img/common/icon-wait.svg?inline";

export default {
  name: "UI.Loading",
  props: {
    loading: Boolean
  },
  data() {
    return {
      IconWait
    };
  },
  computed: {},
  components: {
    [Icon.name]: Icon,
    [Spin.name]: Spin
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style module lang="scss">
@import "~rfs/scss";

.loadingWrapper {
  :global {
    .ant-spin-dot {
      @include rfs(1rem);
    }
  }
}
</style>
